import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import SelectField from '../SelectField';
import InputField from '../InputField';

import { useFormContext } from '../FormContext';
import { useFormUpdateContext } from '../FormContext';
import { buildUrl } from '../../lib/buildUrl';

export default function Form(props) {
    const [urlParams, setUrlParams] = useState({ 
        link: '', 
        utm_medium: '',
        utm_source: '',
        utm_campaign: ''
    });

    const formContext = useFormContext();
    const { setFormInput } = useFormUpdateContext();


    const formContextData = formContext.formData;

    const { parentCallback } = props;


    // Runs whenever the data in the array changes
    useEffect(() => {
        //  Creates the URL and passes it to the parent.

        const { link, ...params } = urlParams;

        const { url: finalUrl, warnings } = buildUrl({ link, params });

        parentCallback(finalUrl, { warnings, params: urlParams });

        setFormInput({
            url: link, params : urlParams, finalUrl
        })

    }, [urlParams, parentCallback, setFormInput]);


    const handleChange = (event) => {
        setUrlParams({ 
            ...urlParams, [event.target.name] : event.target.value
        });
    }

    const generateFormFieldsFromContext = () => {
        // Map the form fields
        const formFields = formContextData.map( (field, i) => {
            if(typeof urlParams[field.name] === 'undefined') { urlParams[field.name] = ''}

            if(field.fieldType === 'input') {
                return (
                    <InputField 
                        title={field.title} 
                        name={field.name}  
                        type={field.type}  
                        onChange={handleChange} 
                        value={urlParams[field.name]}
                        key={i + '_' +field.name}
                        isRequired={ typeof field.isRequired != "undefined" ? field.isRequired : false }
                        validationText={typeof field.validationText != "undefined" ? field.validationText : ''}
                        displayOrder={typeof field.displayOrder != "undefined" ? field.displayOrder : i + 100}
                    />
                );
            } else if(field.fieldType === 'select') {
                return (
                    <SelectField
                        title={field.title} 
                        name={field.name}  
                        type={field.type}  
                        onChange={handleChange} 
                        value={urlParams[field.name]}
                        key={i + '_' +field.name}
                        isRequired={ typeof field.isRequired != "undefined" ? field.isRequired : false }
                        validationText={typeof field.validationText != "undefined" ? field.validationText : ''}
                        displayOrder={typeof field.displayOrder != "undefined" ? field.displayOrder : i + 100}
                        options={field.listValues}
                        useOptGroup={field.listUsesOptGroup}
                    />
                );
            } else {
                return '';
            }
        });
        
        function compare(a, b) {
            const fieldA = a.props.displayOrder;
            const fieldB = b.props.displayOrder;

            let comparison = 0;
            if (fieldA > fieldB) {
                comparison = 1;
            } else if (fieldA < fieldB) {
                comparison = -1;
            }
            return comparison;
        }

        formFields.sort(compare);

        return formFields;
    }

    return(
        <form>
            {generateFormFieldsFromContext()}
        </form>
    );
}

Form.propTypes = {
    name: PropTypes.string
};